import React from "react";
import Headline from "../components/shared/Headline";
import PostsApi from "../../api-services/posts-api.service";
import { useParams } from "react-router-dom";
import { notification } from "antd";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

const bannerPath = '/iceholidays-assets/images/blog.png';
const _breadcrumbs = [
  { title: 'Home' },
  { title: 'Blog' },
] 

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}

class BlogShowPage extends React.Component <{params;}>  {
  postsApi = new PostsApi;

  state = {
    breadcrumbs: _breadcrumbs,
    blog: {title: "", thumbnail: "", content: ""},
  }

  componentDidMount() {
    this.postsApi.getBlog(this.props.params.id)
      .then(blogData => {
        var breadcrumbs = this.state.breadcrumbs;
        breadcrumbs.push({title: blogData.title});
        this.setState({blog: blogData, breadcrumbs})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading blog.'});
      });
  }


  render(){
    const {blog} = this.state;
    return (
      <div id="blog-show-page">
        <Headline bannerImage={bannerPath} breadcrumbs={this.state.breadcrumbs} title="Blog"/>

        <div id="blog-show-page_body">
          <h1>{blog.title}</h1>
          <img src={blog.thumbnail}/>
          <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{blog.content}</Markdown>
        </div>
      </div>
    )
  }
}


export default withParams(BlogShowPage);